import { render, staticRenderFns } from "./RequestsOverview.vue?vue&type=template&id=4bdb2608&scoped=true&"
import script from "./RequestsOverview.vue?vue&type=script&lang=js&"
export * from "./RequestsOverview.vue?vue&type=script&lang=js&"
import style0 from "./RequestsOverview.vue?vue&type=style&index=0&id=4bdb2608&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdb2608",
  null
  
)

export default component.exports